import { render, staticRenderFns } from "./TButtonGroup.vue?vue&type=template&id=c509df12"
import script from "./TButtonGroup.vue?vue&type=script&lang=js"
export * from "./TButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports